import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner, Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import { useNavigate } from 'react-router-dom';
import { handleLoginPopup } from '../../redux/slice/userSlice';
import Cookies from 'js-cookie';
import axios from 'axios';

const OtpVerify = ({ verifyOtp, resendOtp, onClose, phoneNumber, loading }) => {
  const [otp, setOtp] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 4) {
      toast.error("Please enter a 4-digit OTP");
      return;
    }
    await verifyOtp(otp);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-sm p-6 relative animate-fadeIn">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 p-1 rounded-full hover:bg-gray-100 transition"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>

        <div className="text-center mb-6">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-1">Verify your phone</h3>
          <p className="text-sm text-gray-500">
            Code sent to <span className="font-medium text-gray-700">{phoneNumber}</span>
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <div className="flex justify-center space-x-3">
              {[0, 1, 2, 3].map((index) => (
                <input
                  key={index}
                  type="text"
                  value={otp[index] || ''}
                  onChange={(e) => {
                    const newOtp = [...otp];
                    newOtp[index] = e.target.value.replace(/\D/g, '');
                    setOtp(newOtp.join('').slice(0, 4));
                    if (e.target.value && index < 3) {
                      e.target.nextSibling?.focus();
                    }
                  }}
                  maxLength={1}
                  className="w-14 h-14 text-2xl text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  pattern="\d*"
                  inputMode="numeric"
                />
              ))}
            </div>
          </div>

          <button
            type="submit"
            disabled={loading || otp.length !== 4}
            className={`w-full py-3 px-4 rounded-lg font-medium text-white transition ${(loading || otp.length !== 4) ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Verifying...
              </span>
            ) : 'Verify'}
          </button>
        </form>
      </div>
    </div>
  );
};

const EnlistRentalDrone = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = Cookies.get('token');
  const userId = Cookies.get('userId');
  
  // Verification states
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCheckingVerification, setIsCheckingVerification] = useState(true);
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const [checkingRegistration, setCheckingRegistration] = useState(true);
  
  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);

  // Form data state
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
    address: "",
    location: "",
    userType: "individual",
    companyName: "",
    companyAddress: ""
  });

  // Password validation state
  const [passwordValidation, setPasswordValidation] = useState({
    isValid: false,
    match: null,
  });

  // Checkboxes
  const [checkboxState, setCheckboxState] = useState({
    subsidyAcknowledgement: false,
  });

  // Check authentication and verification status on mount
  useEffect(() => {
    if (!token) {
      setIsCheckingVerification(false);
    } else {
      checkPhoneVerification();
    }
  }, [token, dispatch]);

  // Check registration status
// Check registration status
useEffect(() => {
  const checkRegistrationStatus = async () => {
    if (userId) {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL +`/checkDAASRegistration/${userId}`);
        console.log("Registration check response:", response.data);
        
        // Check for both response formats
        if (response.data.registered === true || response.data.message === "DAAS Vendor found") {
          setAlreadyRegistered(true);
        }
      } catch (error) {
        console.error("Error checking registration status:", error);
      } finally {
        setCheckingRegistration(false);
      }
    } else {
      setCheckingRegistration(false);
    }
  };

  checkRegistrationStatus();
}, [userId]);

// Check phone verification status
const checkPhoneVerification = async () => {
  try {
    setIsCheckingVerification(true);
    const response = await axios.get(process.env.REACT_APP_API_URL +`/getInterstedData/${userId}`);
    console.log("Verification check response:", response.data);
    
    if (response.data.data) {
      setPhoneNumber(response.data.data.phoneNumber);
      
      if (response.data.data.verified) {
        setPhoneVerified(true);
        setFormData(prev => ({ 
          ...prev, 
          phoneNumber: response.data.data.phoneNumber,
          name: response.data.data.name || "",
          email: response.data.data.email || "",
          address: response.data.data.address || "",
          location: response.data.data.location || "",
          // userType: response.data.data.userType || "individual",
          companyName: response.data.data.companyName || "",
          companyAddress: response.data.data.companyAddress || "",
          password: "",
          confirmPassword: ""
        }));
      } else {
          setPhoneVerified(true);
        }
      }
    } catch (error) {
      console.error("Error checking phone verification:", error);
    } finally {
      setIsCheckingVerification(false);
    }
  };

  // Handle phone number submission
  const handlePhoneSubmit = async () => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      return;
    }

    if (!phoneNumber || phoneNumber.length !== 10) {
      toast.error("Please enter a valid 10-digit phone number");
      return;
    }

    setLoading(true);
    try {
      await axios.post(process.env.REACT_APP_API_URL +"/savePhone", {
        phoneNumber,
        type: "Rental Drones",
        userId
      });

      setOtpLoading(true);
      const otpResponse = await axios.post(`${process.env.REACT_APP_API_URL}/login`, {
        phoneNumber,
        userId
      });

      if (otpResponse.data.status === "success") {
        toast.success(otpResponse.data.message || "OTP sent successfully");
        setShowModal(true);
      } else {
        toast.error(otpResponse.data.message || "Failed to send OTP");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to initiate verification");
      console.error(error);
    } finally {
      setLoading(false);
      setOtpLoading(false);
    }
  };

  // Verify OTP
  const verifyOtp = async (otp) => {
    try {
      setOtpLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/verifyOtp`, {
        phoneNumber,
        otp,
        userId
      });
      
      if (response.data.status === "success") {
        toast.success(response.data.message || "Phone number verified successfully");
        setPhoneVerified(true);
        setFormData(prev => ({ ...prev, phoneNumber }));
        setShowModal(false);
        
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        
        return true;
      } else {
        toast.error(response.data.message || "Invalid OTP");
        return false;
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP verification failed");
      console.error(error);
      return false;
    } finally {
      setOtpLoading(false);
    }
  };

  // Resend OTP
  const resendOtp = async () => {
    try {
      setOtpLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/resendOtp`, {
        phoneNumber,
        userId
      });
      
      if (response.data.status === "success") {
        toast.success(response.data.message || "OTP resent successfully");
      } else {
        toast.error(response.data.message || "Failed to resend OTP");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to resend OTP");
      console.error(error);
    } finally {
      setOtpLoading(false);
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber" && !/^\d{0,10}$/.test(value)) {
      return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "password") {
      setPasswordValidation((prev) => ({
        ...prev,
        isValid: value.length >= 6,
      }));
    }

    if (name === "confirmPassword") {
      setPasswordValidation((prev) => ({
        ...prev,
        match: value === formData.password ? true : value ? false : null,
      }));
    }
  };

  // Handle checkbox changes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxState({
      ...checkboxState,
      [name]: checked,
    });
  };

  // Handle form submission
// Handle form submission
const submitHandle = async () => {
  if (!token) {
    dispatch(handleLoginPopup(true));
    return;
  }

  const submissionData = {
    ...formData,
    phoneNumber: phoneNumber || formData.phoneNumber,
    userId,
  };

  const requiredFields = [
    "name", "phoneNumber", "email", "password",
    "address", "location", "userType",
  ];

  if (formData.userType === "company") {
    requiredFields.push("companyName", "companyAddress");
  }

  const missingFields = requiredFields.filter((field) => !submissionData[field]);

  if (missingFields.length > 0) {
    toast.error(`Missing required fields: ${missingFields.join(", ")}`);
    return;
  }

  if (!passwordValidation.isValid) {
    toast.error("Password must be at least 6 characters long");
    return;
  }

  if (passwordValidation.match === false) {
    toast.error("Passwords don't match");
    return;
  }

  if (!checkboxState.subsidyAcknowledgement) {
    toast.error("Please accept the terms and conditions");
    return;
  }

  try {
    setLoading(true);
    const response = await axios.post(
      `http://localhost:6002/addDroneRentalVendor`,   // 👈 updated API URL
      submissionData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.status === "success") {
      toast.success(response.data.message || "Vendor registration successful!");
      setAlreadyRegistered(true);
      window.location.reload();
    } else {
      toast.error(response.data.message || "Registration failed");
    }
  } catch (error) {
    console.error("Registration error:", error);
    toast.error(
      error.response?.data?.message ||
        "Vendor registration failed. Please try again."
    );
  } finally {
    setLoading(false);
  }
};

  // Handle location selection
  const handlePlaceSelected = (place) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      // address: place.formatted_address,
      location: [place.geometry.location.lat(), place.geometry.location.lng()].join(','),
    }));
  };

  // Close modal
  const onCloseModal = () => {
    setShowModal(false);
  };

  // Loading state
  if (isCheckingVerification) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

if (alreadyRegistered) {
  return (
    <div 
      id="success-message" 
      className="flex justify-center items-center min-h-screen py-8 px-4"
      style={{ paddingTop: '700px' }}
    >
      <div className="bg-white p-8 sm:p-10 rounded-2xl shadow-xl max-w-md w-full text-center border border-gray-100 mx-4">
        <div className="flex justify-center mb-6">
          <div className="bg-green-100 p-4 rounded-full shadow-sm animate-bounce">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-3">
          Vendor Registration Successful!
        </h2>
        <p className="text-base text-gray-600 mb-4">
          Your DaaS vendor account has been registered successfully.
        </p>
        <div className="bg-blue-50 rounded-lg p-4 mb-6">
          <p className="text-sm text-gray-700">
            Thank you for joining <span className="font-medium text-green-600">Drone Planet's Vendor Network</span>.
          </p>
          <p className="text-sm text-gray-700 mt-2">
            Our team will verify your details and activate your vendor dashboard soon.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
                     to="/"
                     className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition transform hover:scale-105"
                   >
                     Go to Home
                   </Link>
          <a
            href="mailto:vendor-support@droneplanet.in"
            className="px-6 py-3 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition transform hover:scale-105"
          >
            Vendor Support
          </a>
        </div>
      </div>
    </div>
  );
}

  // Unauthenticated users
  if (!token) {
    return (
      <div className="bg-green-50 py-8 px-2 sm:px-4 md:px-6 lg:px-8">
        <div className="w-full max-w-md mx-auto">
          <div className="text-center mb-10">
            <h4 className="text-3xl font-bold text-gray-800">
              Enlist your <span className="text-green-600">DAAS Service</span>
            </h4>
            <p className="mt-2 text-gray-600">Please login to verify your phone number</p>
          </div>

          <div className="bg-white p-8 rounded-xl">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contact Number <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                type="text"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                maxLength="10"
                placeholder="Enter 10-digit phone number"
              />
            </div>

            <button
              onClick={handlePhoneSubmit}
              className="w-full mt-4 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-lg hover:shadow-md transition-all duration-300 hover:from-blue-700 hover:to-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Verify Phone Number
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Authenticated users - phone verification needed
  const shouldShowForm = phoneVerified;

  if (!shouldShowForm) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="w-full max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="bg-blue-600 px-6 py-8 text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 bg-white rounded-full mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">Register Your DAAS Service</h1>
            <p className="text-blue-100">Complete your registration in just 2 simple steps</p>
          </div>

          <div className="flex justify-center px-8 pt-6">
            <div className="w-full max-w-md">
              <div className="flex items-center">
                <div className="flex flex-col items-center">
                  <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold">1</div>
                  <div className="text-sm font-medium text-blue-600 mt-1">Phone Verification</div>
                </div>
                <div className="flex-1 h-1 bg-gray-200 mx-2"></div>
                <div className="flex flex-col items-center">
                  <div className="w-10 h-10 rounded-full bg-gray-200 text-gray-500 flex items-center justify-center font-bold">2</div>
                  <div className="text-sm font-medium text-gray-500 mt-1">Service Details</div>
                </div>
              </div>
            </div>
          </div>

          <div className="px-6 py-8 sm:px-10">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-800">Verify Your Phone Number</h2>
              <p className="text-gray-600 mt-2">We'll send a 4-digit verification code</p>
            </div>

            <div className="max-w-md mx-auto space-y-6">
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                  Mobile Number <span className="text-red-500">*</span>
                </label>
                <div className="relative rounded-md shadow-sm">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span className="text-gray-500 sm:text-sm">+91</span>
                  </div>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                    maxLength="10"
                    className="block w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                    placeholder="9876543210"
                    inputMode="numeric"
                  />
                </div>
              </div>

              <div className="pt-2">
                <button
                  onClick={handlePhoneSubmit}
                  disabled={loading || phoneNumber.length !== 10}
                  className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-lg font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                    loading || phoneNumber.length !== 10 
                      ? 'bg-gray-400 cursor-not-allowed' 
                      : 'bg-blue-600 hover:bg-blue-700'
                  }`}
                >
                  {loading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Sending OTP...
                    </>
                  ) : (
                    'Send Verification Code'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {showModal && (
          <OtpVerify 
            verifyOtp={verifyOtp}
            resendOtp={resendOtp}
            onClose={onCloseModal}
            phoneNumber={phoneNumber}
            loading={otpLoading}
          />
        )}
      </div>
    );
  }

  // Full form for verified users
  return (
    <div className="bg-green-50 py-8 px-2 sm:px-4 md:px-6 lg:px-8">
      <div className="w-full max-w-[205%] sm:max-w-3xl md:max-w-4xl lg:max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h4 className="text-3xl font-bold text-gray-800">
            Enlist your <span className="text-blue-600">DAAS Service</span>
          </h4>
        </div>

        <div className="bg-green-50 p-8 rounded-xl">
          {/* User Type Radio Buttons */}
          <div className="mb-8">
            <label className="block text-lg font-medium text-gray-800 mb-4">
              Registering as: <span className="text-red-500">*</span>
            </label>
            <div className="flex flex-col sm:flex-row sm:justify-center sm:gap-24 gap-4 mt-4">
              <div className="flex items-center">
                <input
                  className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  type="radio"
                  name="userType"
                  id="individual"
                  value="individual"
                  checked={formData.userType === "individual"}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="individual" className="ml-2 block text-gray-700">
                  Individual/Freelancer
                </label>
              </div>
              <div className="flex items-center">
                <input
                  className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  type="radio"
                  name="userType"
                  id="company"
                  value="company"
                  checked={formData.userType === "company"}
                  onChange={handleChange}
                />
                <label htmlFor="company" className="ml-2 block text-gray-700">
                  Company as a co-partner
                </label>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="name">
                Your Name <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

           

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="email">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Location */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="location">
                Location <span className="text-red-500">*</span>
              </label>
              <Autocomplete
                apiKey={process.env.REACT_APP_GOOGLE_KEY}
                onPlaceSelected={handlePlaceSelected}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                options={{
                  types: ["(cities)"],
                  componentRestrictions: { country: "in" },
                }}
                placeholder=""
              />
            </div>

            {/* Address */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="address">
                Address <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="password">
                Password <span className="text-red-500">*</span>
              </label>
              <input
                className={`w-full px-4 py-3 rounded-lg border ${passwordValidation.isValid ? 'border-green-500' : 'border-red-500'} focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all`}
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              {!passwordValidation.isValid && (
                <p className="mt-1 text-sm text-red-600">Password must be at least 6 characters long</p>
              )}
            </div>

            {/* Confirm Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="confirmPassword">
                Confirm Password <span className="text-red-500">*</span>
              </label>
              <input
                className={`w-full px-4 py-3 rounded-lg border ${passwordValidation.match === true ? 'border-green-500' : passwordValidation.match === false ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all`}
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              {passwordValidation.match === false && (
                <p className="mt-1 text-sm text-red-600">Passwords do not match</p>
              )}
              {passwordValidation.match === true && (
                <p className="mt-1 text-sm text-green-600">Passwords match</p>
              )}
            </div>

            {/* Company Fields (conditionally rendered) */}
            {formData.userType === "company" && (
              <>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="companyName">
                    Company Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="companyAddress">
                    Company Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    type="text"
                    name="companyAddress"
                    value={formData.companyAddress}
                    onChange={handleChange}
                    required
                  />
                </div>
              </>
            )}
          </div>

          {/* Terms and Conditions */}
          <div className="flex items-start mt-6">
            <div className="flex items-center h-5">
              <input
                type="checkbox"
                id="subsidyAcknowledgement"
                name="subsidyAcknowledgement"
                checked={checkboxState.subsidyAcknowledgement}
                onChange={handleCheckboxChange}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor="subsidyAcknowledgement" className="font-medium text-gray-700">
                I Accept The{" "}
                <Link to="/terms-and-conditions" className="text-blue-600 hover:text-blue-500 underline">
                  Terms and Conditions
                </Link>
              </label>
            </div>
          </div>

          {/* Submit Button */}
          <button
            onClick={submitHandle}
            className="w-full mt-8 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-lg hover:shadow-md transition-all duration-300 hover:from-blue-700 hover:to-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex justify-center items-center gap-2"
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <>
                Validate and Proceed to Next
                <i className="fas fa-arrow-right"></i>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnlistRentalDrone;